import { useSegment } from '@hooks/use-segment';
import { Button } from '@chakra-ui/react';
import Link from 'next/link';

export function BottomCTA({ applyURL }: { applyURL: string }) {
  const analytics = useSegment();
  return (
    <div className="bg-[#2B1C66] px-10 pb-28 pt-20 text-center text-white ">
      <div className="text-5xl font-bold text-white md:text-6xl">
        Ready to start?
      </div>
      <div className="pt-6 text-base text-gray-300">
        Apply today and get up to 6 months free
      </div>
      <div className="mx-auto mt-5 max-w-md sm:flex sm:justify-center md:mt-8">
        <div
          className="rounded-md"
          onClick={() => {
            analytics.track(`Marketing_For Startups_Apply Now Button Clicked`, {
              surface: 'Marketing',
              location: 'For Startups'
            });
          }}
        >
          <Link href={applyURL} target="_blank" rel="noopener">
            <Button variant="base" minW="225px" fontSize={'md'}>
              Apply Now
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
